export default __webpack_public_path__ + "./image/0aa92b59ac20e70ab8d88b6bcddabef2.png";